import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=139cdda7&"
import script from "./UserSearch.vue?vue&type=script&lang=js&"
export * from "./UserSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports